import React, { useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import { useTranslation } from "react-i18next";
import { useFocusTrap } from "../../../../hook/useFocusTrap";
import { REGISTRATION_KEYBOARD_SCOPE_ATTR } from "../../../RegistrationLayout/registrationFocusStyles";

const BookingConfirmationRetryModal = ({
  isOpen,
  message,
  onRetry,
  onClose,
  isRetrying = false,
}) => {
  const { t } = useTranslation();
  const panelRef = useRef(null);
  const retryButtonRef = useRef(null);

  useFocusTrap({
    isOpen,
    containerRef: panelRef,
    initialFocusRef: retryButtonRef,
    onEscape: isRetrying ? undefined : onClose,
  });

  useEffect(() => {
    if (!isOpen) {
      return undefined;
    }

    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = prevOverflow;
    };
  }, [isOpen]);

  if (!isOpen) {
    return null;
  }

  return createPortal(
    <div
      className="booking-error-modal-overlay"
      role="presentation"
      {...REGISTRATION_KEYBOARD_SCOPE_ATTR}
    >
      <div
        ref={panelRef}
        className="booking-error-modal-panel"
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="booking-error-message"
        onClick={(e) => e.stopPropagation()}
      >
        <p id="booking-error-message" className="booking-error-modal-message">
          {message}
        </p>
        <div className="registration-load-retry-modal-actions">
          {onClose ? (
            <button
              type="button"
              className="btn-ghost registration-load-retry-modal-cancel"
              onClick={onClose}
              disabled={isRetrying}
            >
              {t("CANCEL", { defaultValue: "Cancel" })}
            </button>
          ) : null}
          <button
            ref={retryButtonRef}
            type="button"
            className="btn-primary booking-error-modal-retry"
            onClick={onRetry}
            disabled={isRetrying}
          >
            {t("TRY_AGAIN")}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default BookingConfirmationRetryModal;
